import { useState } from "react"
import { observer } from "mobx-react-lite"
import { Link } from "react-router-dom"

import type { InfoPairsResult } from "@/domains/on-chain"
import type { MinimalPairResponseItem, PairRewardResponseItem } from "@/domains/validators"
import { ShowWhenTrue } from "@/components"
import { Card } from "@/components/card"
import { MetaData } from "@/domains/common/layout/metadata"
import { PageContainer } from "@/domains/common/layout/page-container"
import { PageTitle } from "@/domains/common/layout/page-title"
import { LockRewardsGroupedByNft } from "@/domains/lock-rewards/components/group-by-nft"
import { LockRewardsGroupedByToken } from "@/domains/lock-rewards/components/group-by-token"
import { RewardsPagesComplexBreadcrumbApplication } from "@/domains/navigation/components/complex-breadcrumb-applications/rewards-pages-complex-breadcrumb-application"
import { RewardsLockSubItem } from "@/domains/navigation/subitems/rewards-lock-subitem"
import { GroupVotingRewardsBy } from "@/domains/old-voting-rewards/components/voting-rewards-tabs"

const BREADCRUMB_ITEMS = [new RewardsLockSubItem(), RewardsPagesComplexBreadcrumbApplication]

export type InfoPairWithMetadata = InfoPairsResult & Pick<MinimalPairResponseItem, "displayName" | "token0" | "token1">
export type PairWithRewards = InfoPairWithMetadata & PairRewardResponseItem

const Rewards = observer(() => {
  const [groupBy, setGroupBy] = useState<GroupVotingRewardsBy>("token")

  const title = "Claim Voting Rewards"
  const subTitle = (
    <>
      Weekly rewards earned by casting your{" "}
      <Link to="/vote" className="font-bold">
        votes
      </Link>{" "}
      for fees & bribe incentives to guide new emissions
    </>
  )

  return (
    <PageContainer>
      <MetaData title={title} />
      <PageTitle title={title} items={BREADCRUMB_ITEMS} subTitle={subTitle} />
      <Card.Container className="text-t100">
        <ShowWhenTrue when={groupBy === "nft"}>
          <LockRewardsGroupedByNft groupBy={groupBy} setGroupBy={setGroupBy} />
        </ShowWhenTrue>
        <ShowWhenTrue when={groupBy === "token"}>
          <LockRewardsGroupedByToken groupBy={groupBy} setGroupBy={setGroupBy} />
        </ShowWhenTrue>
      </Card.Container>
    </PageContainer>
  )
})

export default Rewards
